import { useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { useUser } from "@context/contexts";
import { parseSubscriptionEnd, formatDateTime } from "@utils/index";
import PopUp from "./Payment";
import "@css/Profile.css";

const EXPIRING_SOON_DAYS = 14;

// Плашка статуса подписки: зелёная - активна, оранжевая - истекает
// в ближайшие две недели, красная - нет. Клик открывает модалку
// с текущей подпиской и вариантами оплаты.
const SubscriptionBadge = ({ compact, isOpen, onOpen, onClose }) => {
    const { userData } = useUser();

    const { status, label } = useMemo(() => {
        const end = parseSubscriptionEnd(userData?.subscription);
        if (!end || end.isBefore(moment())) {
            return { status: "none", label: "Нет подписки" };
        }
        if (end.diff(moment(), "days") < EXPIRING_SOON_DAYS) {
            return { status: "expiring", label: `Истекает ${formatDateTime(end.toDate(), { day: "2-digit", month: "2-digit" })}` };
        }
        return { status: "active", label: "Подписка активна" };
    }, [userData]);

    return (
        <>
            <button
                type="button"
                className={`subscription-blob subscription-blob--${status}${compact ? " subscription-blob--compact" : ""}`}
                onClick={onOpen}
                title="Показать подписку"
            >
                {label}
            </button>
            {isOpen ? <PopUp closePopUp={onClose} /> : null}
        </>
    );
};

SubscriptionBadge.propTypes = {
    compact: PropTypes.bool,
    isOpen: PropTypes.bool.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default SubscriptionBadge;
